/* =====================================================================
   HD DIGIPRINT™ YACHT MAT DESIGN STATION — BoatMat.com
   Rev 3 — 2026-09-21. Built on the SportFish Design Station framework.
   ONE product: HD DigiPrint™ Yacht Mat with Black Marine-Grade Gripper Backing.

   PRICE AUTHORITY: the Shopify variant id decides the price server-side.
   The amounts below are display-only and mirror the live variants.

   Colors: the real 150-cell BoatMat grid (sportfish-hd-colors.js supplies
   HD_COLORS + HD_SPRITE) shown and carried through as grid codes (A1..O10),
   never as PMS numbers. Carpet plates: artwork.boatmat.com/sportfish/assets/.

   MULTI-MAT ORDERS: Quantity multiplies the current configuration;
   ADD ADDITIONAL MAT banks the current configuration (its own size, color,
   artwork file, placement, quantity, notes) and starts a fresh one. ADD TO
   CART submits every configuration as its own real multipart form post to
   /cart/add (targeted at a hidden iframe, one after another) so EACH artwork
   FILE reaches its own Shopify line item, then opens the cart.
   ===================================================================== */
(function () {
'use strict';

var ASSETS = 'https://artwork.boatmat.com/sportfish/assets/';
var DEFAULT_COLOR_CELL = 'L5';   /* LIGHT GRAY — Patrick: the mat must be visible on the blue page */

/* Five standard sizes only (Patrick 2026-09-21) — larger sizes now go through the
   Custom Size Quote. Retired variants (8x5 729.95 / 10x5 895.95 / 10x6 899.95 /
   12x6 995.95) remain on the Shopify product, just not offered here. */
var SIZES = [
  { key: '3x2',  w: 3,  h: 2, label: "3' × 2'",  price: 325.95, variant: 50148017307927 },
  { key: '4x3',  w: 4,  h: 3, label: "4' × 3'",  price: 369.95, variant: 50148017340695 },
  { key: '5x3',  w: 5,  h: 3, label: "5' × 3'",  price: 399.95, variant: 50148017373463, popular: true },
  { key: '6x4',  w: 6,  h: 4, label: "6' × 4'",  price: 449.95, variant: 50148017438999 },
  { key: '8x4',  w: 8,  h: 4, label: "8' × 4'",  price: 695.95, variant: 50148017471767 }
];

/* Curated mat-text fonts (Patrick 2026-09-22): a small set — clean block styles,
   two scripts, and Hobo (rendered with Kavoon, the licensed Google-Fonts cut of
   the classic Hobo style; the order records the customer's chosen font name and
   production sets the final face at proof time as always). Loaded via Google
   Fonts in the section; document.fonts.load() before drawing so the canvas
   never paints a fallback face. */
/* Exactly five customer-facing styles (Patrick 2026-09-22) — simple names only,
   no technical font-family names shown, and every face has substantial stroke
   weight (prints cleanly; works for embroidery-class lettering too). Thin
   scripts (Great Vibes) and the lighter blocks (Oswald/Montserrat) removed.
   Faces underneath: Bold Block=Archivo Black (unchanged), Serif Block=Noto
   Serif 900, Brush Script=Pacifico, Bold Script=Dancing Script 700,
   Hobo=Kavoon (licensed Hobo-style cut, as before). */
var FONTS = [
  { key: 'boldblock',   label: 'Bold Block',   css: "'Archivo Black', sans-serif",   weight: '400' },
  { key: 'serifblock',  label: 'Serif Block',  css: "'Noto Serif', 'Times New Roman', serif", weight: '900' },
  { key: 'brushscript', label: 'Brush Script', css: "'Pacifico', cursive",           weight: '400' },
  { key: 'boldscript',  label: 'Bold Script',  css: "'Dancing Script', cursive",     weight: '700' }
];

var S = {
  customMode: false,
  size: SIZES[2],
  color: null,
  /* Step 3 is LOGO OR TEXT, never both (Patrick 2026-09-22) — a simple general
     representation, not a design program. mode drives which controls show and
     switching modes clears the other option's content from the preview. */
  mode: 'logo',
  logo: null, logoFile: null, logoName: '',
  txt: { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 },
  qty: 1,
  saved: [],                       /* banked configurations */
  art: { scale: 0.6, dx: 0, dy: 0 }
};
function hasText() { return S.txt.value.trim() !== ''; }
function hasDesign() { return !!S.logo || hasText(); }

function el(id) { return document.getElementById(id); }
function money(n) { return '$' + n.toFixed(2); }

/* =============== STEP 1 — SIZES =============== */
function buildSizes() {
  var host = el('hdSizes'); if (!host) return;
  host.innerHTML = '';
  SIZES.forEach(function (z) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'szcard' + (!S.customMode && S.size.key === z.key ? ' on' : '');
    b.innerHTML = (z.popular ? '<span class="pop">MOST POPULAR</span>' : '')
      + '<span class="sz">' + z.label + '</span><span class="pr">' + money(z.price) + '</span>';
    b.onclick = function () { S.customMode = false; S.size = z; buildSizes(); syncTotals(); draw(); };
    host.appendChild(b);
  });
  var c = document.createElement('button');
  c.type = 'button'; c.className = 'szcard custom';
  c.innerHTML = '<span class="sz">CUSTOM SIZE</span><span class="pr">Quoted individually</span>';
  c.onclick = function () { hdymCsqOpen(); };
  host.appendChild(c);
}

/* =============== PRICE / QTY / TOTALS =============== */
function savedTotal() { return S.saved.reduce(function (a, m) { return a + m.price * m.qty; }, 0); }
function syncTotals() {
  var p = el('hdPrice'), btn = el('hdAddCart'), sl = el('hdSizeLabel'), q = el('hdQty'),
      sc = el('hdSumColor'), tot = el('hdTotal');
  if (q) q.textContent = String(S.qty);
  if (sc) sc.textContent = S.color ? S.color.c : DEFAULT_COLOR_CELL;
  var total = savedTotal();
  if (false) { /* custom sizes now go through the quote modal */ } else {
    if (p) p.textContent = money(S.size.price) + (S.qty > 1 ? '  × ' + S.qty : '');
    if (sl) sl.textContent = S.size.label;
    if (btn) btn.textContent = 'ADD TO CART — ' + money(total + S.size.price * S.qty);
    total += S.size.price * S.qty;
  }
  if (tot) tot.textContent = money(total);
  renderSaved();
}
window.hdymQty = function (d) { S.qty = Math.min(10, Math.max(1, S.qty + d)); syncTotals(); };

/* =============== STEP 2 — COLORS (grid codes only) =============== */
function buildColors() {
  var host = el('hdColors'); if (!host || !window.HD_COLORS || !window.HD_SPRITE) return;
  host.innerHTML = '';
  var sp = window.HD_SPRITE;
  window.HD_COLORS.forEach(function (c) {
    var col = c.c.charCodeAt(0) - 65;
    var row = parseInt(c.c.slice(1), 10) - 1;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sw' + (S.color && S.color.c === c.c ? ' on' : '');
    b.title = c.c; b.setAttribute('aria-label', 'Mat color ' + c.c);
    b.style.backgroundColor = c.h;
    b.style.backgroundImage = 'url(' + (window.HDYM_SPRITE_URL || (ASSETS + 'hd-sprite.jpg')) + ')';
    b.style.backgroundSize = (sp.cols * 100) + '% ' + (sp.rows * 100) + '%';
    b.style.backgroundPosition = (col / (sp.cols - 1) * 100) + '% ' + (row / (sp.rows - 1) * 100) + '%';
    b.onclick = function () { setColor(c); };
    b.dataset.cell = c.c;
    host.appendChild(b);
  });
}
var tileCache = {};
function tileImg(code, cb) {
  if (tileCache[code]) { cb(tileCache[code]); return; }
  var im = new Image();
  im.crossOrigin = 'anonymous';
  im.onload = function () { tileCache[code] = im; cb(im); };
  im.onerror = function () { cb(null); };
  im.src = ASSETS + 'hd-tile-' + code + '.jpg';
}
function setColor(c) {
  S.color = c;
  var host = el('hdColors');
  if (host) [].forEach.call(host.children, function (b) { b.classList.toggle('on', b.dataset.cell === c.c); });
  var nm = el('hdColorName'); if (nm) nm.textContent = c.c;
  syncTotals();
  tileImg(c.c, function () { draw(); });
}

/* =============== STEP 3 — LOGO =============== */
function wireUpload() {
  var inp = el('hdLogoFile'); if (!inp) return;
  inp.addEventListener('change', function () {
    var f = inp.files && inp.files[0]; if (!f) return;
    var url = URL.createObjectURL(f);
    var im = new Image();
    im.onload = function () {
      S.logo = im; S.logoFile = f; S.logoName = f.name;
      S.art = { scale: 0.6, dx: 0, dy: 0 };
      /* Pre-encode for the gallery round-trip snapshot: FileReader is async, so
         doing this at CLICK time loses the race against navigation — encode once
         here instead, long before any gallery click. */
      S.logoDataUrl = null;
      if (f.size <= 2.5 * 1024 * 1024) {
        try {
          var fr2 = new FileReader();
          fr2.onload = function () { S.logoDataUrl = fr2.result; };
          fr2.readAsDataURL(f);
        } catch (e2) { /* snapshot just won't carry the logo */ }
      }
      var th = el('hdUpTh'); if (th) { th.src = url; th.style.display = 'block'; }
      var tx = el('hdUpTxt'); if (tx) tx.textContent = f.name + ' — uploaded. Your mat preview is below.';
      var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
      draw();
      var pv = el('hdPreviewWrap'); if (pv && pv.scrollIntoView) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    im.onerror = function () {
      var tx = el('hdUpTxt'); if (tx) tx.textContent = 'That file could not be read as an image — please try a PNG, JPG, SVG or WEBP.';
    };
    im.src = url;
  });
}
function clearLogo() {
  S.logo = null; S.logoFile = null; S.logoName = '';
  var inp = el('hdLogoFile'); if (inp) inp.value = '';
  S.logoDataUrl = null;
  var th = el('hdUpTh'); if (th) { th.removeAttribute('src'); th.style.display = 'none'; }
  var tx = el('hdUpTxt'); if (tx) tx.textContent = 'UPLOAD YOUR YACHT LOGO HERE';
  var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = true;
}
function nudge(dxPct, dyPct) { S.art.dx += dxPct; S.art.dy += dyPct; draw(); }
function scaleArt(f) { S.art.scale = Math.min(0.96, Math.max(0.1, S.art.scale * f)); draw(); }
function resetArt() { S.art = { scale: 0.6, dx: 0, dy: 0 }; draw(); }

/* =============== STEP 3 — ADD TEXT =============== */
function loadTxtFont(cb) {
  var f = S.txt.font;
  if (document.fonts && document.fonts.load) {
    document.fonts.load(f.weight + ' 60px ' + f.css).then(function () { cb(); }).catch(function () { cb(); });
  } else cb();
}
function wireText() {
  var inp = el('hdTextInput'), sel = el('hdTextFont');
  if (sel) {
    FONTS.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f.key; o.textContent = f.label;
      sel.appendChild(o);
    });
    sel.onchange = function () {
      S.txt.font = FONTS.filter(function (f) { return f.key === sel.value; })[0] || FONTS[0];
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on font change */
      loadTxtFont(draw);
    };
  }
  if (inp) {
    inp.addEventListener('input', function () {
      S.txt.value = inp.value;
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on every wording change */
      var c = el('hdTxtCtrls'); if (c) c.hidden = S.mode !== 'text' || !hasText();
      loadTxtFont(draw);
    });
  }
}
function clearText() {
  S.txt = { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 };
  var inp = el('hdTextInput'); if (inp) inp.value = '';
  var sel = el('hdTextFont'); if (sel) sel.value = FONTS[0].key;
  var c = el('hdTxtCtrls'); if (c) c.hidden = true;
}
/* Text is ALWAYS true-center (Patrick 2026-09-22) — no positioning controls,
   only a size adjustment. dx/dy stay 0; draw() centers and clamps. */
function txtScale(f) { S.txt.scale = Math.min(1.4, Math.max(0.16, S.txt.scale * f)); S.txt.dx = 0; S.txt.dy = 0; draw(); }
function updateModeUI() {
  var isLogo = S.mode === 'logo';
  var bL = el('hdModeLogo'), bT = el('hdModeText');
  if (bL) { bL.classList.toggle('on', isLogo); bL.setAttribute('aria-pressed', isLogo ? 'true' : 'false'); }
  if (bT) { bT.classList.toggle('on', !isLogo); bT.setAttribute('aria-pressed', !isLogo ? 'true' : 'false'); }
  var up = el('hdUpWrap'); if (up) up.hidden = !isLogo;
  var ac = el('hdArtCtrls'); if (ac) ac.hidden = !isLogo || !S.logo;
  var tb = el('hdTxtBox'); if (tb) tb.hidden = isLogo;
  var tc = el('hdTxtCtrls'); if (tc) tc.hidden = isLogo || !hasText();
}
window.hdymMode = function (m) {
  if (m !== 'logo' && m !== 'text') return;
  if (S.mode === m) { updateModeUI(); return; }
  S.mode = m;
  if (m === 'logo') clearText(); else clearLogo();
  updateModeUI(); syncTotals(); draw();
};

/* =============== THE PREVIEW =============== */
/* Physical geometry — anchored to the ACTUAL manufactured product (LogoMats LLC
   DigiPrint HD, verified 2026-10-27 against the manufacturer's own proof
   renderings and product scenes + published construction specs):
     · flat printed PET cut-pile carpet face, full bleed to the edge
     · a BLACK nitrile-rubber edge EXACTLY 1" wide on ALL four sides (CONFIRMED manufacturer spec 2026-10-27; constant physical
       width — so it reads thinner on a big mat and wider on a small one)
     · corners effectively SQUARE (only a slight softening)
     · NO stitched/bound edge band, NO gloss sheen — the old preview drew both
       and they do not exist on the manufactured mat (removed 2026-10-27).
   The finished (ordered) size INCLUDES the rubber edge; the printed carpet face
   is therefore about 2" smaller per axis. Artwork is kept a safety margin
   inside the printed face so production tolerance (±3–5%) can never clip it. */
var CVW = 1200;
var BORDER_IN = 1.0;   /* black rubber edge, inches (constant on the real mat) */
var SAFE_IN = 1.0;     /* artwork safety margin inside the printed face, inches */
var CORNER_IN = 0.5;   /* near-square corner softening, inches */
function matGeom() {
  var wIn = S.size.w * 12, hIn = S.size.h * 12;
  var W = CVW, H = Math.round(CVW * (hIn / wIn));
  var ppi = W / wIn;                                   /* canvas px per real inch */
  var frame = Math.max(3, Math.round(ppi * BORDER_IN));
  var safe = Math.max(3, Math.round(ppi * SAFE_IN));
  var r = Math.max(2, Math.round(ppi * CORNER_IN));
  return { W: W, H: H, ppi: ppi, frame: frame, safe: safe, r: r,
           /* kept for wireDrag()'s existing math */ bind: frame + safe };
}
function draw(cb) {
  var cv = el('hdCv'); if (!cv) { if (cb) cb(); return; }
  var g = matGeom();
  var pad = 70;
  cv.width = g.W + pad * 2; cv.height = g.H + pad * 2;
  var x = pad, y = pad;
  var ctx = cv.getContext('2d');
  ctx.clearRect(0, 0, cv.width, cv.height);

  /* soft neutral ground shadow — presentation only, outside the mat itself */
  ctx.save();
  ctx.filter = 'blur(18px)';
  ctx.fillStyle = 'rgba(0,0,0,.35)';
  ctx.fillRect(x + 10, y + g.H - 4, g.W - 20, 16);
  ctx.restore();

  /* the black nitrile-rubber edge — flat, uniform ~1" all round, square corners */
  ctx.fillStyle = '#0a0b0d';
  roundRect(ctx, x, y, g.W, g.H, g.r); ctx.fill();

  /* printed carpet face: finished size minus the rubber edge, full-bleed print */
  var fx = x + g.frame, fy = y + g.frame;
  var fw = g.W - g.frame * 2, fh = g.H - g.frame * 2;
  var fr = Math.max(1, g.r - Math.round(g.frame * 0.4));
  var code = S.color ? S.color.c : DEFAULT_COLOR_CELL;
  var fallback = S.color ? S.color.h : '#DCE0E5';
  tileImg(code, function (tile) {
    ctx.save();
    roundRect(ctx, fx, fy, fw, fh, fr); ctx.clip();
    if (tile) ctx.fillStyle = ctx.createPattern(tile, 'repeat');
    else ctx.fillStyle = fallback;
    ctx.fillRect(fx, fy, fw, fh);
    ctx.restore();

    /* artwork lives inside the printed face, inset by the safety margin */
    var innerX = fx + g.safe, innerY = fy + g.safe;
    var innerW = fw - g.safe * 2, innerH = fh - g.safe * 2;
    if (S.logo) {
      var ar = S.logo.naturalHeight / S.logo.naturalWidth;
      var aw = innerW * S.art.scale, ah = aw * ar;
      if (ah > innerH * 0.96) { ah = innerH * 0.96; aw = ah / ar; }
      var cx = innerX + innerW / 2 + S.art.dx * innerW;
      var cy = innerY + innerH / 2 + S.art.dy * innerH;
      cx = Math.max(innerX + aw / 2, Math.min(innerX + innerW - aw / 2, cx));
      cy = Math.max(innerY + ah / 2, Math.min(innerY + innerH - ah / 2, cy));
      S.art.dx = (cx - innerX - innerW / 2) / innerW;
      S.art.dy = (cy - innerY - innerH / 2) / innerH;
      ctx.save();
      roundRect(ctx, innerX, innerY, innerW, innerH, 4); ctx.clip();
      ctx.shadowColor = 'rgba(0,0,0,.18)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
      ctx.drawImage(S.logo, cx - aw / 2, cy - ah / 2, aw, ah);
      ctx.restore();
    }
    if (hasText()) {
      /* Printed mat text — sized from the mat, clamped inside the printed face's
         safety margin, auto black/white for contrast against the carpet color. */
      var tstr = S.txt.value.trim();
      var fsize = innerH * 0.42 * S.txt.scale;
      ctx.save();
      roundRect(ctx, innerX, innerY, innerW, innerH, 4); ctx.clip();
      ctx.font = S.txt.font.weight + ' ' + Math.round(fsize) + 'px ' + S.txt.font.css;
      var tw = ctx.measureText(tstr).width;
      if (tw > innerW * 0.94) { fsize = fsize * (innerW * 0.94) / tw; ctx.font = S.txt.font.weight + ' ' + Math.round(fsize) + 'px ' + S.txt.font.css; tw = ctx.measureText(tstr).width; }
      var hex = (S.color ? S.color.h : '#DCE0E5').replace('#', '');
      var lum = (parseInt(hex.substr(0, 2), 16) * 0.299 + parseInt(hex.substr(2, 2), 16) * 0.587 + parseInt(hex.substr(4, 2), 16) * 0.114) / 255;
      /* true center of the mat, clamped inside the printable safety margin */
      var tx2 = innerX + innerW / 2;
      var ty2 = innerY + innerH / 2;
      tx2 = Math.max(innerX + tw / 2, Math.min(innerX + innerW - tw / 2, tx2));
      ty2 = Math.max(innerY + fsize / 2, Math.min(innerY + innerH - fsize / 2, ty2));
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(0,0,0,.22)'; ctx.shadowBlur = 5; ctx.shadowOffsetY = 2;
      ctx.fillStyle = lum > 0.55 ? '#101820' : '#FFFFFF';
      ctx.fillText(tstr, tx2, ty2);
      ctx.restore();
    }
    if (!S.logo && !hasText()) {
      ctx.save();
      ctx.fillStyle = code === DEFAULT_COLOR_CELL ? 'rgba(20,30,45,.45)' : 'rgba(255,255,255,.4)';
      ctx.font = '600 ' + Math.round(g.H * 0.07) + 'px Barlow, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('YOUR YACHT LOGO OR TEXT HERE', x + g.W / 2, y + g.H / 2);
      ctx.restore();
    }
    var cap = el('hdCvCap');
    if (cap) cap.textContent = 'HD DigiPrint™ Yacht Mat — ' + S.size.label +
      ' · Color ' + code
      + ' — shown to scale with the standard 1-inch black rubber edge (confirmed manufacturer specification); the finished size includes the edge. Screen colors are an approximation — production is matched to BoatMat HD color chart cell ' + code + '.';
    if (cb) cb(cv);
  });
}
function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wireDrag() {
  var cv = el('hdCv'); if (!cv) return;
  var dragging = false, last = null;
  function pos(e) {
    var r = cv.getBoundingClientRect();
    var sx = cv.width / r.width, sy = cv.height / r.height;
    var t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * sx, y: (t.clientY - r.top) * sy };
  }
  function down(e) { /* logo dragging on the mat disabled (Patrick 2026-09-29) — use the Adjust Your Logo buttons under Step 4 */ }
  function move(e) {
    if (!dragging || !last) return;
    var p = pos(e), g = matGeom();
    /* dx/dy are fractions of the printable inner area (face minus safety margin) */
    S.art.dx += (p.x - last.x) / (g.W - (g.frame + g.safe) * 2);
    S.art.dy += (p.y - last.y) / (g.H - (g.frame + g.safe) * 2);
    last = p; draw(); e.preventDefault();
  }
  function up() { dragging = false; last = null; }
  cv.addEventListener('pointerdown', down);
  window.addEventListener('pointermove', move, { passive: false });
  window.addEventListener('pointerup', up);
  cv.addEventListener('touchstart', down, { passive: false });
  window.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('touchend', up);
}

/* =============== SAVED CONFIGURATIONS =============== */
function currentThumb() {
  try { var cv = el('hdCv'); return cv ? cv.toDataURL('image/jpeg', 0.5) : null; } catch (e) { return null; }
}
/* Full-quality preview capture for the order proof (Patrick 2026-09-21): the
   exact pixels the customer sees, downscaled to <=1200px wide to keep the
   upload small. Uploaded to BMOS at Add-to-Cart; the returned permanent URL
   rides the line item so the cart AND the order proof PDF can show the real
   configured mat. A failed upload never blocks the sale. */
var DP_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/design-proof/preview';
function capturePreview() {
  try {
    var cv = el('hdCv'); if (!cv || !cv.width) return null;
    var MAXW = 1200;
    if (cv.width <= MAXW) return cv.toDataURL('image/png');
    var s2 = MAXW / cv.width;
    var c2 = document.createElement('canvas');
    c2.width = MAXW; c2.height = Math.round(cv.height * s2);
    c2.getContext('2d').drawImage(cv, 0, 0, c2.width, c2.height);
    return c2.toDataURL('image/png');
  } catch (e) { return null; }
}
function uploadPreview(cfg, cb) {
  if (!cfg.preview || !window.fetch) { cb(); return; }
  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
  fetch(DP_ENDPOINT, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ png: cfg.preview, station: 'hd-yachtmat',
      config: { size: cfg.label, sizeFt: cfg.sizeFt, color: cfg.colorC, qty: cfg.qty, placement: cfg.placement, file: cfg.logoName, text: cfg.text || '', textPlacement: cfg.textPlacement || null } }),
    signal: ctrl ? ctrl.signal : undefined
  }).then(function (r) { return r.json(); })
    .then(function (j) { clearTimeout(t); if (j && j.ok) { cfg.previewId = j.id; cfg.previewUrl = j.url; } cb(); })
    .catch(function () { clearTimeout(t); cb(); });
}
function renderSaved() {
  var host = el('hdSavedMats'); if (!host) return;
  host.hidden = S.saved.length === 0;
  host.innerHTML = '';
  S.saved.forEach(function (m, i) {
    var d = document.createElement('div');
    d.className = 'savedmat';
    d.innerHTML =
      (m.thumb ? '<img class="th" src="' + m.thumb + '" alt="">' : '<span class="th" style="background:' + m.hex + ';display:inline-block"></span>')
      + '<span class="meta"><b>Mat ' + (i + 1) + ' — ' + m.label + ' · Color ' + m.colorC + ' · Qty ' + m.qty + '</b>'
      + '<span class="d">' + (m.logoName || (m.text ? '“' + m.text + '”' : 'artwork attached')) + (m.notes ? ' · note added' : '') + '</span></span>'
      + '<span class="pr">' + money(m.price * m.qty) + '</span>'
      + '<button type="button" class="rm" data-i="' + i + '">Remove</button>';
    d.querySelector('.rm').onclick = function () { S.saved.splice(i, 1); syncTotals(); };
    host.appendChild(d);
  });
}
window.hdymAddAdditional = function () {
  var msg = el('hdCartMsg');
  if (!hasDesign()) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Upload this mat’s logo or add text first</b> (Step 3), then ADD ADDITIONAL MAT banks it and starts your next mat.'; }
    return;
  }
  if (msg) msg.hidden = true;
  var color = S.color || { c: DEFAULT_COLOR_CELL, h: '#DCE0E5' };
  S.saved.push({
    label: S.size.label, sizeKey: S.size.key, sizeFt: S.size.w + ' x ' + S.size.h,
    variant: S.size.variant, price: S.size.price,
    colorC: color.c, hex: color.h, qty: S.qty,
    file: S.logoFile, logoName: S.logoName,
    placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
    text: S.txt.value.trim(), textFont: S.txt.font.label,
    textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
    notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
    thumb: currentThumb(),
    preview: capturePreview()
  });
  /* fresh canvas for the next mat */
  clearLogo();
  clearText();
  S.mode = 'logo'; updateModeUI();
  S.qty = 1;
  if (el('hdNotes')) el('hdNotes').value = '';
  syncTotals(); draw();
  var s1 = el('hdStep1'); if (s1 && s1.scrollIntoView) s1.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

/* =============== ADD TO CART (multi-config, real multipart posts) =============== */
function designId() {
  var d = new Date();
  var p = function (n) { return (n < 10 ? '0' : '') + n; };
  return 'HDY-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
    p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + '-' +
    Math.random().toString(36).slice(2, 6).toUpperCase();
}
function cartFrame() {
  var f = el('hdymCartFrame');
  if (!f) {
    f = document.createElement('iframe');
    f.id = 'hdymCartFrame'; f.name = 'hdymCartFrame'; f.style.display = 'none';
    document.body.appendChild(f);
  }
  return f;
}
function submitConfig(cfg, done) {
  var form = document.createElement('form');
  form.method = 'post'; form.action = '/cart/add'; form.enctype = 'multipart/form-data';
  form.target = 'hdymCartFrame'; form.style.display = 'none';
  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    form.appendChild(i);
  }
  hidden('id', String(cfg.variant));
  hidden('quantity', String(cfg.qty));
  hidden('properties[Size]', cfg.label);
  hidden('properties[Mat Color]', cfg.colorC);
  hidden('properties[Backing]', 'Black Marine-Grade Gripper Backing');
  if (cfg.text) { hidden('properties[Mat Text]', cfg.text); hidden('properties[Text Font]', cfg.textFont); }
  if (cfg.notes) hidden('properties[Special Notes]', cfg.notes);
  hidden('properties[_design_id]', designId());
  hidden('properties[_hd_chart_cell]', cfg.colorC);
  hidden('properties[_mat_size_ft]', cfg.sizeFt);
  hidden('properties[_artwork_placement]', JSON.stringify(Object.assign({}, cfg.placement, { file: cfg.logoName })));
  if (cfg.textPlacement) hidden('properties[_text_placement]', JSON.stringify(Object.assign({ text: cfg.text }, cfg.textPlacement)));
  hidden('properties[_designed_at]', new Date().toISOString());
  hidden('properties[_design_station]', 'hd-yachtmat');
  if (cfg.previewId) hidden('properties[_preview_id]', cfg.previewId);
  if (cfg.previewUrl) hidden('properties[_preview_url]', cfg.previewUrl);
  hidden('properties[_proof_status]', 'AWAITING PROOF APPROVAL');
  if (cfg.file && window.DataTransfer) {
    try {
      var fi = document.createElement('input');
      fi.type = 'file'; fi.name = 'properties[■ Artwork File]';
      var dt = new DataTransfer();
      dt.items.add(cfg.file);
      fi.files = dt.files;
      form.appendChild(fi);
    } catch (e) { /* very old browser: config still carts, file noted in placement */ }
  }
  var frame = cartFrame();
  var settled = false;
  function finish() { if (settled) return; settled = true; form.remove(); done(); }
  frame.addEventListener('load', finish, { once: true });
  setTimeout(finish, 6000);
  document.body.appendChild(form);
  form.submit();
}
window.hdymAddToCart = function () {
  var msg = el('hdCartMsg');
  var queue = S.saved.slice();
  if (hasDesign()) {
    var color = S.color || { c: DEFAULT_COLOR_CELL, h: '#DCE0E5' };
    queue.push({
      label: S.size.label, sizeFt: S.size.w + ' x ' + S.size.h, variant: S.size.variant,
      price: S.size.price, colorC: color.c, qty: S.qty, file: S.logoFile, logoName: S.logoName,
      placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
      text: S.txt.value.trim(), textFont: S.txt.font.label,
      textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
      notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
      preview: capturePreview()
    });
  }
  if (!queue.length) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Please upload your yacht logo or add your mat text first</b> — Step 3 above. Questions? Call 321.751.4636.'; }
    var st = el('hdStep3'); if (st && st.scrollIntoView) st.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  if (msg) msg.hidden = true;
  var btn = el('hdAddCart');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
  var i = 0;
  (function next() {
    if (i >= queue.length) { window.location.href = '/cart'; return; }
    var cfg = queue[i++];
    if (btn && queue.length > 1) btn.textContent = 'Adding mat ' + i + ' of ' + queue.length + '…';
    uploadPreview(cfg, function () { submitConfig(cfg, next); });
  })();
};

/* =============== CUSTOM SIZE QUOTE MODAL =============== */
var CSQ_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/custom-size-quote';
function csqRow(vals) {
  var host = el('csqRows'); if (!host) return;
  var d = document.createElement('div');
  d.className = 'csq-row';
  d.innerHTML = '<input type="text" maxlength="30" placeholder="Width (e.g. 9\')" class="w">'
    + '<input type="text" maxlength="30" placeholder="Length (e.g. 4\')" class="l">'
    + '<input type="number" min="1" max="999" value="' + ((vals && vals.qty) || 1) + '" class="q" aria-label="Quantity">'
    + '<button type="button" class="rm" aria-label="Remove size">&times;</button>';
  d.querySelector('.rm').onclick = function () {
    if (el('csqRows').children.length > 1) d.remove();
    else { d.querySelector('.w').value = ''; d.querySelector('.l').value = ''; d.querySelector('.q').value = 1; }
  };
  host.appendChild(d);
}
window.hdymCsqAddRow = function () { csqRow(); };
function trapModal(m, closeFn) {
  if (!m || m.__a11y) return; m.__a11y = 1;
  m.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && closeFn) { closeFn(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(m.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
}
window.hdymCsqOpen = function () {
  var m = el('hdCsq'); if (!m) return;
  el('csqForm').hidden = false; el('csqDone').hidden = true;
  var err = el('csqErr'); if (err) err.hidden = true;
  if (!el('csqRows').children.length) csqRow();
  m.hidden = false;
  document.body.style.overflow = 'hidden';
  trapModal(m, window.hdymCsqClose);
  var _cf = m.querySelector('input,button,a,select,textarea'); if (_cf) { try { _cf.focus(); } catch (e) {} }
};
window.hdymCsqClose = function () {
  var m = el('hdCsq'); if (m) m.hidden = true;
  document.body.style.overflow = '';
};
window.hdymCsqSend = function () {
  var err = el('csqErr');
  function fail(t) { if (err) { err.hidden = false; err.textContent = t; } }
  var rows = [].map.call(el('csqRows').children, function (d) {
    return { width: d.querySelector('.w').value.trim(), length: d.querySelector('.l').value.trim(), qty: d.querySelector('.q').value };
  }).filter(function (r) { return r.width && r.length; });
  var name = el('csqName').value.trim(), email = el('csqEmail').value.trim(), phone = el('csqPhone').value.trim();
  if (!rows.length) return fail('Please enter at least one size — width and length.');
  if (!name) return fail('Please enter your name.');
  if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) return fail('Please enter a valid email address.');
  if (!phone) return fail('Please enter your phone number.');
  if (err) err.hidden = true;
  var btn = el('csqSend');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  /* upload any attached artwork first (optional; sequential; a failure keeps
     the form intact so the customer can remove the file or retry) */
  var qa = window.bmQuoteArt, qaq = qa && qa.csq;
  (qaq && qaq.items.length ? function (go) {
    qa.uploadAll(qaq, function (t) { if (btn) btn.textContent = t; }, function (ok, errText) {
      if (!ok) { if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; } fail(errText); return; }
      if (btn) btn.textContent = 'Sending…';
      go();
    });
  } : function (go) { go(); })(function () {
  fetch(CSQ_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: name, email: email, phone: phone,
      vessel: el('csqVessel').value.trim(),
      notes: el('csqNotes').value.trim(),
      company: el('csqCompany').value,
      sizes: rows,
      artworks: qaq ? qa.list(qaq) : [],
      pageUrl: window.location.href.split('?')[0]
    })
  }).then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
    .then(function (j) {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      if (j && j.ok) { el('csqForm').hidden = true; el('csqDone').hidden = false; }
      else fail((j && j.error) || 'Something went wrong — please call 321.751.4636.');
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      fail('Could not reach our server — please try again or call 321.751.4636.');
    });
  });
};

/* =============== BOOT =============== */
/* =============== GALLERY ROUND-TRIP STATE (Patrick 2026-09-22) ===============
   The gallery's "Return to Previous Page" button is history.back(); the gallery
   now opens in the SAME tab so back() lands here. Browsers usually restore this
   page from the back-forward cache with everything intact — but when one
   reloads instead, this sessionStorage snapshot (saved at the moment the
   customer clicks a gallery link) puts their in-progress design back: size,
   color, quantity, text + font + placement, and the uploaded logo (kept as a
   data URL when ≤2.5MB and rebuilt into a real File so Add to Cart still
   attaches it). Snapshot expires after 60 minutes. */
var GAL_STATE_KEY = 'bmHdymGalleryState';
function saveGalleryState() {
  try {
    var st = {
      at: Date.now(), mode: S.mode, sizeKey: S.size.key, color: S.color, qty: S.qty,
      art: S.art, txt: { value: S.txt.value, fontKey: S.txt.font.key, scale: S.txt.scale, dx: S.txt.dx, dy: S.txt.dy },
      logoName: S.logoName || '', logoData: null
    };
    if (S.logo && S.logoDataUrl) st.logoData = S.logoDataUrl;
    try { sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
    catch (e) { st.logoData = null; sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
  } catch (e) { /* storage unavailable — bfcache still covers the common case */ }
}
function wireGallerySave() {
  ['hdGalTop', 'hdGalBottom'].forEach(function (id) {
    var a = el(id); if (a) a.addEventListener('click', saveGalleryState);
  });
}
function restoreGalleryState() {
  var raw = null;
  try { raw = sessionStorage.getItem(GAL_STATE_KEY); } catch (e) { return; }
  if (!raw) return;
  var st = null;
  try { st = JSON.parse(raw); } catch (e) { return; }
  if (!st || !st.at || Date.now() - st.at > 60 * 60000) { try { sessionStorage.removeItem(GAL_STATE_KEY); } catch (e) {} return; }
  var z = SIZES.filter(function (x) { return x.key === st.sizeKey; })[0];
  if (z) { S.size = z; buildSizes(); }
  if (st.qty >= 1 && st.qty <= 10) S.qty = st.qty;
  if (st.mode === 'text' || st.mode === 'logo') { S.mode = st.mode; updateModeUI(); }
  if (st.art && typeof st.art.scale === 'number') S.art = st.art;
  if (st.txt && st.txt.value && S.mode === 'text') {
    S.txt.value = st.txt.value;
    S.txt.font = FONTS.filter(function (f) { return f.key === st.txt.fontKey; })[0] || FONTS[0];
    S.txt.scale = st.txt.scale; S.txt.dx = 0; S.txt.dy = 0;   /* always true center */
    var ti = el('hdTextInput'); if (ti) ti.value = st.txt.value;
    var sel = el('hdTextFont'); if (sel) sel.value = S.txt.font.key;
    loadTxtFont(function () {});
  }
  if (st.color && st.color.c) {
    /* applied after the color chart loads — boot's waitColors calls us back */
    S.__restoreColor = st.color;
  }
  if (st.logoData && st.logoName && S.mode === 'logo') {
    fetch(st.logoData).then(function (r) { return r.blob(); }).then(function (blob) {
      var f = new File([blob], st.logoName, { type: blob.type || 'image/png' });
      var im = new Image();
      im.onload = function () {
        S.logo = im; S.logoFile = f; S.logoName = st.logoName;
        var th = el('hdUpTh'); if (th) { th.src = st.logoData; th.style.display = 'block'; }
        var tx = el('hdUpTxt'); if (tx) tx.textContent = st.logoName + ' — uploaded. Your mat preview is below.';
        var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
        syncTotals(); draw();
      };
      im.src = st.logoData;
    }).catch(function () {});
  }
  updateModeUI(); syncTotals(); draw();
}

function boot() {
  buildSizes(); wireUpload(); wireText(); wireDrag(); wireGallerySave();
  restoreGalleryState();
  var tries = 0;
  (function waitColors() {
    if (window.HD_COLORS && window.HD_SPRITE) {
      buildColors();
      var want = S.__restoreColor && S.__restoreColor.c ? S.__restoreColor.c : DEFAULT_COLOR_CELL;
      var def = window.HD_COLORS.filter(function (c) { return c.c === want; })[0]
        || window.HD_COLORS.filter(function (c) { return c.c === DEFAULT_COLOR_CELL; })[0] || window.HD_COLORS[0];
      setColor(def);
      delete S.__restoreColor;
    } else if (tries++ < 100) setTimeout(waitColors, 60);
    else { syncTotals(); draw(); }
  })();
  syncTotals();
  window.hdymNudge = nudge; window.hdymScale = scaleArt; window.hdymReset = resetArt;
  window.hdymTxtScale = txtScale;
  updateModeUI();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
